module.exports = __webpack_public_path__ + "static/img/nodata.328c411.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/UI/nodata.png
// module id = 7RoH
// module chunks = 1